<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button type="primary" @click="addGoodsItem">添加商品</el-button>
        <ImportDialog buttonName="导入商品" fileName="导入商品" fileType="crm_register_setting_item"
          @closeDialog="refresh"></ImportDialog>
        <el-button type="primary" @click="deleteGoodsItem">批量删除</el-button>
        <span class="float-right">是否开启购买注册<el-switch v-model="openStatus" @change="changeRegisterItem"
            active-color="#13ce66" inactive-color="#ff4949"></el-switch></span>
      </el-col>
    </el-row>
    <!-- split-count 为 finder 表格布局参数，不是每页条数；每页条数由底部分页与接口 pageSize/page_size 决定 -->
    <SpFinder ref="finder" row-key="id" :split-count="10" row-actions-width="200" :url="table_url" :setting="setting"
      reserve-selection @select="handleSelectChange" @select-all="handleSelectAll"
      :hooks="{
        beforeSearch: beforeSearch,
        afterSearch: afterSearch
      }" />
  </div>
</template>
<script>
import ImportDialog from '@/components/importDialog'
import { goodsTableSetting } from '../config'
import { goodsList, registerItem, batchDelete, registerSettingCreate } from '../api'
export default {
  components: {
    ImportDialog
  },
  props: {
    orgData: Object
  },
  data() {
    return {
      table_url: goodsList,
      openStatus: false,
      // 已勾选的商品
      tableData: []
    }
  },
  computed: {
    setting() {
      return goodsTableSetting(this)
    }
  },
  mounted() {

  },

  methods: {
    /** finder 全局钩子传 pageSize，接口原为 page_size，与 PHP 对齐避免每页条数不生效 */
    beforeSearch(params) {
      return {
        ...params,
        page_size: params.pageSize != null ? params.pageSize : params.page_size,
      }
    },
    refresh() {
      this.$refs.finder.refresh()
    },
    handleSelectChange(data) {
      this.tableData = data
    },
    handleSelectAll(data) {
      this.tableData = data
    },
    async addGoodsItem() {
      const { data } = await this.$picker.goodsitem({
        data: this.tableData,
        multiple: true,
        queryParams: {
          is_sku: false,
        },
      })
      const params = {
        rel_type: 'item',
        rel_ids: data.map(item => item.goods_id),
      }
      await registerSettingCreate(params)
      this.$message.success('添加成功')
      this.refresh()
    },
    deleteGoodsItem() {
      if (this.tableData.length === 0) {
        this.$message.error('请选择要删除的商品')
        return
      }

      this.$confirm('请确认是否批量删除？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async() => {
          let ids = this.tableData.map(item => item.id)
          await batchDelete({ ids })
          this.$message.success('删除成功')
          this.refresh()
        })
    },
    changeRegisterItem(val) {
      registerItem({ status: val })
    },
    afterSearch(response) {
      const { open_status } = response.data.data
      this.openStatus = open_status
    }
  }
};
</script>
<style scoped lang="scss">
.float-right {
  color: #1480e3;
  float: right;
}
</style>
